import React, { useEffect, useState } from 'react';
import foundersImage from '../../../assets/website/images/founder_image.jpg';
import OutStorySection from './outStory';
import Services from './services';
import * as commonServices from '../services/website.services';
import Swal from 'sweetalert2';
import { ROLE_OPTIONS_FOR_WEBSITE, SWAL_SETTINGS } from '../../../utils/Constants';
import { handleServerValidations } from '../../../utils/commonfunction';

const CITY_LIST = [
  { name: 'Boston', status: 'COMING SOON', live: false },
  { name: 'NYC', status: 'ON THE LIST', live: false },
  { name: 'Chicago', status: 'ON THE LIST', live: false },
];

function WebsiteHomePage() {
  const [waitlistForm, setWaitlistForm] = useState({ name: '', email: '', city: '' });
  const [submitting, setSubmitting] = useState(false);
  const [globalSettings, setGlobalSettings] = useState({});

  useEffect(() => {
    commonServices.GlobalSettingsDetails()
      .then((res) => { if (res?.data) setGlobalSettings(res.data); })
      .catch(() => {});
  }, []);

  const handleWaitlistChange = (e) => {
    const { name, value } = e.target;
    setWaitlistForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleWaitlistSubmit = (e) => {
    e.preventDefault();
    const { name, email, city } = waitlistForm;

    if (!name.trim() || !email.trim() || !city.trim()) {
      Swal.fire({ icon: 'error', text: 'Please fill in name, email, and city.', ...SWAL_SETTINGS });
      return;
    }

    const formData = new FormData();
    formData.append('hereFor', ROLE_OPTIONS_FOR_WEBSITE[0].value);
    formData.append('firstName', name.trim());
    formData.append('lastName', '');
    formData.append('email', email.trim());
    formData.append('message', `City waitlist: ${city.trim()}`);

    setSubmitting(true);
    commonServices.savePrelaunch(formData)
      .then((response) => {
        if (response.success) {
          Swal.fire({ icon: 'success', text: response.message, ...SWAL_SETTINGS });
          setWaitlistForm({ name: '', email: '', city: '' });
        } else {
          Swal.fire({ icon: 'error', text: handleServerValidations(response), ...SWAL_SETTINGS });
        }
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({ icon: 'error', text: 'Something went wrong. Please try again.', ...SWAL_SETTINGS });
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <main>
      <section className="banner-section ">
        <div className="container-fluid">
          <div className="heading-content position-absolute">
            <div className="heading-1">
              <h1>Supporting women <br /> at <span className="ed_los_alamos">every</span> stage</h1>
            </div>
            <p className="">because, babe, it ain't easy.™</p>

            <div className="button-group d-flex gap-3">
              <a
                href="#get-app"
                className="btn btn-white decoration-none"
              >
               App Coming Soon
              </a>
              <a href="/about" className="btn btn-white-outline decoration-none">
                about babe.
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="about-banner-section section-padding">
        <div className="container">
          <div className="banner-content">
            <div className="banner-text section-head">
              <h1 className="h1-headline">
                Supporting women at every stage, because, babe, it ain’t easy
              </h1>
            </div>
          </div>
        </div>
      </section> */}


      <section className="comming_soon section-padding">
        <div className="container">
          <div className="comming-soon-content text-center">
            <span className="subheading">stay in the know</span>
            <h2 className="h2 ink">Coming Soon to Boston</h2>
            <div className="d-flex justify-content-center">
              <a href="/early-access" className="btn btn-purple decoration-none">
                Sign up for Early Access
              </a>
            </div>
          </div>
        </div>
      </section>


      <section className="det_section">
        <div className="container-fluid">
          <div className="row row-gap-4">
            <div className="col-lg-4 col-md-6">
              <span>vetted</span>
              <p>one mandatory background-check. license verification that matters.</p>
            </div>
            <div className="col-lg-4 col-md-6">
              <span>ON-DEMAND</span>
              <p>connect in no time, all the time.</p>
            </div>
            <div className="col-lg-4">
              <span>local</span>
              <p>your city, your neighborhood, your schedule.</p>
            </div>
          </div>
        </div>
      </section>


      <section className="the_truth">
        <div className="container-fluid">
          <div className="row row-gap-4">
            <div className="col-lg-6">
              <div className="text-box pe-5 mt-lg-5">
                <span className="subheading">the truth</span>
                <h2 className="h2 ink">you don’t just need <br /> a village.
                  <br />
                  you need <span>babe.<span style={{ fontSize: '12px' }}>®</span></span></h2>
                <p className="ink">for moments like these, get on-demand services that come to you, so you don’t have to do it all alone.</p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="truth-chat ms-lg-auto">
                <div>
                  <span>09 : 31 pm</span>
                  <p>Ugh couldn&apos;t sit with my dad all week - feel awful</p>
                </div>
                <div>
                  <span>10 : 48 pm</span>
                  <p>John&apos;s work trip got extended! I can NOT give myself this IVF shot!</p>
                </div>
                <div>
                  <span>11 : 47 pm</span>
                  <p>i can&apos;t keep scrolling social postings for childcare....fml</p>
                </div>
                <div>
                  <span>12 : 14 am</span>
                  <p>
                  i don't just need a village.
                    <br /> 
                    i need babe.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <Services />

      <OutStorySection />


      <section className="where_we_are">
        <div className="container-fluid">
          <div className="row align-items-center g-4">
            <div className="col-lg-6">
              <div className="where_we_are__content">
                <span className="subheading">where we are</span>
                <h2 className="h2 ink mb-3">we don't roll out. <br /> we move in. </h2>
                <p className="ink">
                  your city. your neighborhood. your schedule.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="city-waitlist">
                <ul className="city-waitlist__cities">
                  {CITY_LIST.map((city) => (
                    <li key={city.name} className="city-waitlist__row">
                      <span className="city-waitlist__name">
                        <strong>babe. {city.name}</strong>
                      </span>
                      <span className={`city-waitlist__status ${city.live ? 'is-live' : ''}`}>
                        {city.status}
                      </span>
                    </li>
                  ))}
                </ul>
                <form className="city-waitlist__form" onSubmit={handleWaitlistSubmit}>
                  <b className="city-waitlist__heading ink">ready for babe. to hit your city?</b>
                  <div className="city-waitlist__fields">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="name"
                      value={waitlistForm.name}
                      onChange={handleWaitlistChange}
                      required
                    />
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="email"
                      value={waitlistForm.email}
                      onChange={handleWaitlistChange}
                      required
                    />
                    <input
                      type="text"
                      name="city"
                      className="form-control"
                      placeholder="city"
                      value={waitlistForm.city}
                      onChange={handleWaitlistChange}
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-purple ink fw-medium w-100" disabled={submitting}>
                    {submitting ? 'Submitting...' : 'Get on the list'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>



      <section className="from-founders">
        <div className="container-fluid">
          <div className="row align-items-center row-gap-5">
            <div className="col-lg-6">
              <div className="from-founders__content">
                <span className="from-founders__label">from the founders</span>
                <div className="from-founders__text">
                  <p>
                    Karli came to a point many women know all too well: while delighting in the wonders of becoming a new mom, she was still replaying what it took to get there; a challenging pregnancy &amp; postpartum season, heartbreaking pregnancy loss, and grueling IVF process. She simultaneously was solely responsible for her father who was diagnosed with Alzheimer&apos;s. Doing it all without typical family support. She saw this all as an open door to support millions of women experiencing the same. Stefany encountered a similar inflection point. With her career trajectory was on a steep climb she faced the harsh reality of finding reliable child care.
                  </p>
                  <p>
                    Both women left their roles due to a corporate mandate that would have forced them to relocate at 8 months pregnant. They made a decision to build the solution they couldn&apos;t find. The result is babe. Proving if a woman wants something done right, she&apos;ll just have to build it herself.
                  </p>
                </div>
                <span className="from-founders__signature ed_los_alamos">karli + stef</span>
              </div>
            </div>
            <div className="col-lg-6">
              <figure className="from-founders__figure">
                <img src={foundersImage} alt="Karli and Stefany, babe co-founders" width="426" height="505" />
              </figure>
            </div>
          </div>
        </div>
      </section>






    </main>
  );
}

export default WebsiteHomePage;
